import React from 'react'
import FillCaution from 'images/modules/Manage/i-fill-caution.svg?raw'

export { default as FillCautionUrl } from 'images/modules/Manage/i-fill-caution.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: FillCaution}} />
)
